import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/space/$threadId")({
  component: lazyRouteComponent(() => import("@/pages/SpacePage"), "SpacePage"),
});
